import React from 'react';
import './CaseItem.css';

import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

// Import PhotoView from react-photo-view
import { PhotoView } from 'react-photo-view';



const CaseItem = (props) => {

  // Destructuring props
  const { id, image, title, category, caseStudy, className } = props;

  return (
    <div className={`case-item ${className}`} key={id}>
      <div className="case-content">

        {/* Case Study Image */}
        <img src={image} alt={title} />

        {/* Case Study Content */}
        <div className='content'>

          {/* Plus icon for lightbox */}
          <PhotoView src={image}>
            <div className='view'>
              <div className='icon'><FaPlus /></div>
            </div>
          </PhotoView>

          <div className='text'>

            {/* Link to the individual Case Study Detail Page */}
            <Link
              to={{
                pathname: '/Case-Studies/' + title,
              }}
              state={caseStudy}
            >
              <h3>{title}</h3> {/* Case Study Title */}
            </Link>

            {/* Case Study Category */}
            <p>{category}</p>

          </div>

        </div>

      </div>
    </div>
  );
};

export default CaseItem;